<template>
    <div class="company-timeslot-form-component">
        
        <div class="row">
            <div class="col-md col-sm-6 col-6 mb-2" v-for="day in [1,2,3,4,5,6,7]" :key="day">
                <div class="btn btn-sm btn-block" :class="[selectedDay == day ? 'btn-primary' : 'btn-gray']" @click="selectDay(day)"> <!-- timeslot.days[day] = !timeslot.days[day] -->
                    {{ 'days.day_' + day | translate }}
                </div>
            </div>
        </div>

        <hr />

        <div class="row mb-2">
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-4 mb-3" v-for="timeslot in formTimeslots" :key="timeslot.id">
                        <div class="btn btn-sm btn-danger mr-2" @click="removeTimeslot(timeslot)"><i class="fa fa-trash" /></div>
                        <a href="#" class="d-inline-block align-middle" style="line-height: 0.9rem;" :class="{'text-success': selectedTimeslot && selectedTimeslot.id == timeslot.id}" @click="selectedTimeslot = timeslot">
                            {{ timeslot.label }}
                            <br />
                            <small>{{ timeslot.description }}</small>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card" v-if="selectedTimeslot">
                    <div class="card-header">{{ selectedTimeslot.label }}</div>
                    <div class="card-body">
                        
                        <!-- max_guests_inside -->
                        <div class="form-group">
                            <label for="max_guests_inside" class="">{{ 'timeslot_form.max_guests_inside' | translate }}</label>
                            <select class="form-control" style="width: auto;" :class="{'is-invalid': errors.max_guests_inside}" id="max_guests_inside" v-model="selectedTimeslot.max_guests_inside">
                                <option :value="null">{{ 'timeslot_form.default' | translate }}</option>
                                <option value="0">0</option>
                                <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
                            </select>

                            <div v-if="errors.max_guests_inside" class="invalid-feedback">
                                {{ errors.max_guests_inside[0] }}
                            </div> 
                        </div>
                        
                        <!-- max_guests_outside -->
                        <div class="form-group">
                            <label for="max_guests_outside" class="">{{ 'timeslot_form.max_guests_outside' | translate }}</label>
                            <select class="form-control" style="width: auto;" :class="{'is-invalid': errors.max_guests_outside}" id="max_guests_outside" v-model="selectedTimeslot.max_guests_outside">
                                <option :value="null">{{ 'timeslot_form.default' | translate }}</option>
                                <option value="0">0</option>
                                <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
                            </select>

                            <div v-if="errors.max_guests_outside" class="invalid-feedback">
                                {{ errors.max_guests_outside[0] }}
                            </div> 
                        </div>

                        <button class="btn btn-primary" @click="saveSelectedTimeslot">{{ 'timeslot_form.save_timeslot' | translate }}</button>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="form-inline">
                    <label class="mr-2 mr-md-4">{{ 'timeslot_form.time_from' | translate }}</label>
                    
                    <vue-timepicker format="HH:mm" v-model="new_time_from" hide-clear-button auto-scroll input-width="100px" :input-class="{'form-control': true, 'bg-white': true, 'is-invalid': !isValidTime(new_time_from, false)}"></vue-timepicker>

                    <label class="mx-2 ml-md-4 mr-md-4">{{ 'timeslot_form.time_to' | translate }}</label>

                    <vue-timepicker format="HH:mm" v-model="new_time_to" hide-clear-button auto-scroll input-width="100px" :input-class="{'form-control': true, 'bg-white': true , 'is-invalid': !isValidTime(new_time_to, true)}"></vue-timepicker>

                    <input type="text" class="form-control form-control-sm col-md-3 col-sm-10 mt-2 mt-md-0 ml-md-3 mr-3" :placeholder="'timeslot_form.description' | translate" v-model="new_description">

                    <button class="btn btn-success" :disabled="!isValidTime(new_time_from, false) || !isValidTime(new_time_to, true)" @click="addTimeslot()">{{ 'timeslot_form.add_timeslot' | translate }}</button>
                </div>
            </div>
        </div>

        <hr class="my-3">

        <div class="row">
            <div class="col">

                <!-- use_table_setup -->
                <div class="form-group mb-0">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="use_table_setup" :class="{'is-invalid': errors.use_table_setup}" v-model="form.use_table_setup">
                        <label class="custom-control-label" for="use_table_setup">{{ 'timeslot_form.use_table_setup' | translate }}</label>
                    </div>

                    <div v-if="errors.use_table_setup" class="invalid-feedback">
                        {{ errors.use_table_setup[0] }}
                    </div>
                </div>

                <!-- table_setup -->
                <div v-if="form.use_table_setup" class="mt-2 ml-4">
                    
                    <div v-for="(tables, size) in form.table_setup" :key="size" class="form-group form-inline mb-1">
                        <label for="table_setup" class=" col-form-label col-form-label-sm mr-3">{{ 'timeslot_form.table_setup' | translate }} {{ size }}</label>
                                <select class="form-control form-control-sm float-right" style="width: auto;" :class="{'is-invalid': errors.table_setup}" id="table_setup" v-model="form.table_setup[size]">
                                    <option value="0">0</option>
                                    <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
                                </select>

                            <div v-if="errors.table_setup" class="invalid-feedback">
                                {{ errors.table_setup[0] }}
                            </div> 
                    </div>

                </div>

            </div>
        </div>

        <hr class="my-3">

        <div class="row">
            <div class="col">
                
                <!-- reservation_deposit -->
                <div class="form-group row">
                    <label for="reservation_deposit" class="col-sm-3 col-form-label">{{ 'timeslot_form.reservation_deposit' | translate }}<span class="required">*</span></label>
                    <div class="col-sm-3">
                        <currency-input v-model="form.reservation_deposit" class="form-control" :class="{'is-invalid': errors.reservation_deposit}" />

                        <div v-if="errors.reservation_deposit" class="invalid-feedback">
                            {{ errors.reservation_deposit[0] }}
                        </div> 
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        
                        <!-- max_guests_inside -->
                        <div class="form-group row">
                            <label for="max_guests_inside" class="col-sm-9 col-form-label">{{ 'timeslot_form.max_guests_inside' | translate }}<span class="required">*</span></label>
                            <div class="col-sm-3">
                                <select class="form-control float-right" style="width: auto;" :class="{'is-invalid': errors.max_guests_inside}" id="max_guests_inside" v-model="form.max_guests_inside" required>
                                    <option value="0">0</option>
                                    <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
                                </select>

                                <div v-if="errors.max_guests_inside" class="invalid-feedback">
                                    {{ errors.max_guests_inside[0] }}
                                </div> 
                            </div>
                        </div>
                        
                        <!-- guests_inside_text -->
                        <div class="form-group row">
                            <label for="guests_inside_text" class="col-sm-6 col-form-label">{{ 'timeslot_form.guests_inside_text' | translate }}</label>
                            <div class="col-sm-6">
                                <input type="text" class="form-control float-right" :class="{'is-invalid': errors.guests_inside_text}" id="guests_inside_text" v-model="form.guests_inside_text">

                                <div v-if="errors.guests_inside_text" class="invalid-feedback">
                                    {{ errors.guests_inside_text[0] }}
                                </div> 
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6">

                        <!-- max_guests_outside -->
                        <div class="form-group row">
                            <label for="max_guests_outside" class="col-sm-9 col-form-label">{{ 'timeslot_form.max_guests_outside' | translate }}<span class="required">*</span></label>
                            <div class="col-sm-3">
                                <select class="form-control float-right" style="width: auto;" :class="{'is-invalid': errors.max_guests_outside}" id="max_guests_outside" v-model="form.max_guests_outside" required>
                                    <option value="0">0</option>
                                    <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
                                </select>

                                <div v-if="errors.max_guests_outside" class="invalid-feedback">
                                    {{ errors.max_guests_outside[0] }}
                                </div> 
                            </div>
                        </div>
                        
                        <!-- guests_outside_text -->
                        <div class="form-group row">
                            <label for="guests_outside_text" class="col-sm-6 col-form-label">{{ 'timeslot_form.guests_outside_text' | translate }}</label>
                            <div class="col-sm-6">
                                <input type="text" class="form-control float-right" :class="{'is-invalid': errors.guests_outside_text}" id="guests_outside_text" v-model="form.guests_outside_text">

                                <div v-if="errors.guests_outside_text" class="invalid-feedback">
                                    {{ errors.guests_outside_text[0] }}
                                </div> 
                            </div>
                        </div>

                    </div>
                </div>

                <!-- max_group_size -->
                <div class="form-group row">
                    <label for="max_group_size" class="col-sm-9 col-form-label">{{ 'timeslot_form.max_group_size' | translate }}<span class="required">*</span></label>
                    <div class="col-sm-3">
                        <select class="form-control float-right" style="width: auto;" :class="{'is-invalid': errors.max_group_size}" id="max_group_size" v-model="form.max_group_size" required>
                            <option value="0">0</option>
                            <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
                        </select>

                        <div v-if="errors.max_group_size" class="invalid-feedback">
                            {{ errors.max_group_size[0] }}
                        </div> 
                    </div>
                </div>

                <!-- days_in_advance -->
                <div class="form-group row">
                    <label for="days_in_advance" class="col-sm-9 col-form-label">{{ 'timeslot_form.days_in_advance' | translate }}<span class="required">*</span></label>
                    <div class="col-sm-3">
                        <select class="form-control float-right" style="width: auto;" :class="{'is-invalid': errors.days_in_advance}" id="days_in_advance" v-model="form.days_in_advance" required>
                            <option value="0">{{ 'timeslot_form.days_in_advance_unlimited' | translate }}</option>
                            <option v-for="n in 120" :key="n" :value="n">{{ n }}</option>
                        </select>

                        <div v-if="errors.days_in_advance" class="invalid-feedback">
                            {{ errors.days_in_advance[0] }}
                        </div> 
                    </div>
                </div>
                
                <!-- cancel_days_in_advance -->
                <div class="form-group row">
                    <label for="cancel_days_in_advance" class="col-sm-9 col-form-label">{{ 'timeslot_form.cancel_days_in_advance' | translate }}<span class="required">*</span></label>
                    <div class="col-sm-3">
                        <select class="form-control float-right" style="width: auto;" :class="{'is-invalid': errors.cancel_days_in_advance}" id="cancel_days_in_advance" v-model="form.cancel_days_in_advance" required>
                            <option value="0">{{ 'timeslot_form.cancel_days_in_advance_unlimited' | translate }}</option>
                            <option v-for="n in 24" :key="n" :value="n">{{ n }}</option>
                        </select>

                        <div v-if="errors.cancel_days_in_advance" class="invalid-feedback">
                            {{ errors.cancel_days_in_advance[0] }}
                        </div> 
                    </div>
                </div>

                <!-- notify_guests -->
                <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="notify_guests" :class="{'is-invalid': errors.notify_guests}" v-model="form.notify_guests">
                        <label class="custom-control-label" for="notify_guests">{{ 'timeslot_form.notify_guests' | translate }}</label>
                    </div>

                    <div v-if="errors.notify_guests" class="invalid-feedback">
                        {{ errors.notify_guests[0] }}
                    </div>
                </div>
                
                <!-- allow_multiple_per_day -->
                <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="allow_multiple_per_day" :class="{'is-invalid': errors.allow_multiple_per_day}" v-model="form.allow_multiple_per_day">
                        <label class="custom-control-label" for="allow_multiple_per_day">{{ 'timeslot_form.allow_multiple_per_day' | translate }}</label>
                    </div>

                    <div v-if="errors.allow_multiple_per_day" class="invalid-feedback">
                        {{ errors.allow_multiple_per_day[0] }}
                    </div>
                </div>

                <!-- reservation_description -->
                <div class="form-group">
                    <label for="reservation_description" class="form-label">{{ 'timeslot_form.reservation_description' | translate }}</label>

                    <textarea :class="{ 'form-control': true, 'is-invalid': errors.reservation_description}" id="reservation_description" v-model="form.reservation_description"></textarea>
                    <div v-if="errors.reservation_description" class="invalid-feedback">
                        {{ errors.reservation_description[0] }}
                    </div> 
                </div>
                
                <!-- font_family -->
                <div class="form-group">
				    <label for="font_family" class="form-label">{{ 'timeslot_form.font_family' | translate }}</label>
                    <vue-bootstrap-typeahead
                        v-model="fontQuery"
                        :data="fonts"
                        :serializer="s => s.family"
                        :placeholder="company.font_family"
                        @hit="form.font = $event"
                    ></vue-bootstrap-typeahead>
                    
                    <div v-if="errors.font_family" class="invalid-feedback">
                        {{ errors.font_family[0] }}
                    </div>
                </div>

            </div>
            <div class="col" style="flex: 0 0 260px; max-width: 260px;">
                
                <!-- color_primary -->
                <div class="form-group">
                    <label for="color_primary" :class="{'text-danger': errors.color_primary}">{{ 'timeslot_form.color_primary' | translate }}</label>

                    <color-picker v-model="form.color_primary" />

                    <div v-if="errors.color_primary" class="text-danger">
                        {{ errors.color_primary[0] }}
                    </div>
                </div>

            </div>
        </div>

        <button type="button" class="btn btn-secondary mt-4" @click="saveTimeslotData()">{{ 'timeslot_form.submit' | translate }}</button>

    </div>
</template>

<script>
    export default {
		name: 'company-timeslot-form',
		props: [
            'company',
            'timeslots',
            'fonts',
            'removeTimeslotUrl',
            'addTimeslotUrl',
            'saveTimeslotUrl',
            'saveDataUrl',
		],
		data() {
			return {
				csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                locale: window.default_locale,
                
                fontQuery: '',

                selectedDay: 1,
                selectedTimeslot: null,

                new_time_from: '',
                new_time_to: '',
                new_description: '',
                
                form: {
                    timeslots: {1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: []},

                    use_table_setup: false,
                    table_setup: {},

                    reservation_deposit: 0,
                    max_guests_inside: '',
                    guests_inside_text: '',
                    max_guests_outside: '',
                    guests_outside_text: '',
                    max_group_size: '',
                    days_in_advance: 0,
                    cancel_days_in_advance: 0,
                    notify_guests: 0,
                    allow_multiple_per_day: 0,
                    reservation_description: '',
                    color_primary: '',
                    font: null,

                },

                errors: {},
            }
        },
        created() {

            for (let i = 1; i <= 8; i++) {
                this.form.table_setup[i] = 0;
            }

            if(this.company.table_setup) {
                this.form.use_table_setup = true;
                _.assign(this.form.table_setup, this.company.table_setup);
            }

            this.form.reservation_deposit = this.company.reservation_deposit;
            this.form.max_guests_inside = this.company.max_guests_inside;
            this.form.guests_inside_text = this.company.guests_inside_text;
            this.form.max_guests_outside = this.company.max_guests_outside;
            this.form.guests_outside_text = this.company.guests_outside_text;
            this.form.max_group_size = this.company.max_group_size;
            this.form.days_in_advance = this.company.days_in_advance;
            this.form.cancel_days_in_advance = this.company.cancel_days_in_advance;
            this.form.notify_guests = this.company.notify_guests;
            this.form.allow_multiple_per_day = this.company.allow_multiple_per_day;
            this.form.reservation_description = this.company.reservation_description;
            this.form.color_primary = this.company.color_primary ? {hex: this.company.color_primary} : '';
            this.form.font_family = this.company.font_family;

            _.each(this.timeslots, (timeslot) => {
                this.form.timeslots[timeslot.day].push({
                    id: timeslot.id,
                    time_from: timeslot.time_from,
                    time_to: timeslot.time_to,
                    label: timeslot.label,
                    description: timeslot.description,
                    max_guests_inside: timeslot.max_guests_inside,
                    max_guests_outside: timeslot.max_guests_outside,
                });
            });

            /*let api_key = "AIzaSyD70rpGPkWG9rHJ43-uhsGQiH7-gIOv7LI";
            
            axios.get('https://www.googleapis.com/webfonts/v1/webfonts?key=' + api_key)
            .then(response => {
                console.log(response);
            }).catch(error => {
            });*/
        },
        methods: {

            selectDay(day) {
                this.selectedDay = day;
                this.selectedTimeslot = null;
            },

            removeTimeslot(timeslot) {
                this.deleteConfirm.fire({
                }).then((result) => {
                    if(result.value) {

                        this.showLoader();

                        axios.post(this.removeTimeslotUrl, {
                            timeslot_id: timeslot.id
                        })
                        .then(response => {
                            this.hideLoader();
                            
                            if(response.data.success) {
                                Vue.delete(this.form.timeslots[this.selectedDay], _.findIndex(this.form.timeslots[this.selectedDay], ['id', response.data.timeslot_id]));
                            }
                        }).catch(error => {
                            this.hideLoader();

                            if(error && error.response && error.response.status == 422) {
                                if(error.response.data.message) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: error.response.data.message,
                                    });
                                }
                            } else {
                                Swal.fire({
                                    icon: 'error',
                                    title: this.translate('error'),
                                });
                            }
                        });

                    }
                });
            },
            
            addTimeslot() {
                if(!this.isValidTime(this.new_time_from, false) || !this.isValidTime(this.new_time_to, true)) return;
            
                this.showLoader();

                axios.post(this.addTimeslotUrl, {
                    day: this.selectedDay,
                    time_from: this.new_time_from,
                    time_to: this.new_time_to,
                    description: this.new_description,
                })
                .then(response => {
                    this.hideLoader();
                    
                    if(response.data.success) {
                        this.form.timeslots[response.data.timeslot.day].push(response.data.timeslot);
                    }
                }).catch(error => {
                    this.hideLoader();

                    if(error && error.response && error.response.status == 422) {
                        if(error.response.data.message) {
                            Swal.fire({
                                icon: 'error',
                                title: error.response.data.message,
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: this.translate('error'),
                        });
                    }
                });

            },

            saveSelectedTimeslot()
            {
                if(!this.selectedTimeslot) return;

                this.showLoader();

                axios.post(this.saveTimeslotUrl, {
                    timeslot_id: this.selectedTimeslot.id,
                    max_guests_inside: this.selectedTimeslot.max_guests_inside,
                    max_guests_outside: this.selectedTimeslot.max_guests_outside,
                })
                .then(response => {
                    this.hideLoader();
                    
                    if(response.data.success) {
                        // remove and add again
                        Vue.delete(this.form.timeslots[this.selectedDay], _.findIndex(this.form.timeslots[this.selectedDay], ['id', response.data.timeslot.id]));
                        this.form.timeslots[response.data.timeslot.day].push(response.data.timeslot);
                        this.selectedTimeslot = null; //response.data.timeslot;

                        Swal.fire({
                            icon: 'success',
                            title: this.translate('timeslot_form.success'),
                        });
                    }
                }).catch(error => {
                    this.hideLoader();

                    if(error && error.response && error.response.status == 422) {
                        if(error.response.data.message) {
                            Swal.fire({
                                icon: 'error',
                                title: error.response.data.message,
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: this.translate('error'),
                        });
                    }
                });
            },
            
            saveTimeslotData() {
                
                this.showLoader();

                axios.post(this.saveDataUrl, {
                    use_table_setup: this.form.use_table_setup,
                    table_setup: this.form.table_setup,
                    reservation_deposit: this.form.reservation_deposit,
                    max_guests_inside: this.form.max_guests_inside,
                    guests_inside_text: this.form.guests_inside_text,
                    max_guests_outside: this.form.max_guests_outside,
                    guests_outside_text: this.form.guests_outside_text,
                    max_group_size: this.form.max_group_size,
                    days_in_advance: this.form.days_in_advance,
                    cancel_days_in_advance: this.form.cancel_days_in_advance,
                    notify_guests: this.form.notify_guests,
                    allow_multiple_per_day: this.form.allow_multiple_per_day,
                    reservation_description: this.form.reservation_description,
                    color_primary: this.form.color_primary.hex,
                    font_family: this.form.font ? this.form.font.family : null
                })
                .then(response => {
                    this.hideLoader();
                    
                    if(response.data.success) {
                        this.errors = {};

                        Swal.fire({
                            icon: 'success',
                            title: this.translate('timeslot_form.success'),
                        });
                    }
                }).catch(error => {
                    this.hideLoader();

                    if(error && error.response && error.response.status == 422) {
                        this.errors = error.response.data.errors;

                        if(error.response.data.message) {
                            Swal.fire({
                                icon: 'error',
                                title: error.response.data.message,
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: this.translate('error'),
                        });
                    }
                });

            },

            isValidTime(time, allowEmpty) {
                if(allowEmpty && time == '') return true;

                return /^([0-9]{2}:[0-9]{2})$/.test(time);
            },
        },
        computed: {

            formTimeslots: function() {
                let timeslots = this.form.timeslots[this.selectedDay];
                return _.sortBy(timeslots, ['time_from']);
            }

        }
    }
</script>